import '../../styles/tabs/normalTabs.scss';
import CustomSVGs from '../customSVGs/CustomSVGs';

type TabItem = {
  text: string;
  count: number;
  icon: any | null;
  isActive: boolean;
};

type Props = {
  tabItems?: TabItem[];
  onTabClick?: (index: number) => void;
  showCountInTab?: string;
};

const NormalTabs = ({ tabItems, onTabClick, showCountInTab }: Props) => {
  return (
    <div className='normalTabs' role='tablist'>
      {tabItems?.map((item, index) => (
        <button
          role='tab'
          aria-selected={item.isActive}
          data-is-tab-active={item.isActive.toString()}
          className='normalTabs__tab'
          key={index}
          onClick={() => onTabClick?.(index)}
          tabIndex={item.isActive ? 0 : -1}
        >
          {item.icon && (
            <div className='normalTabs__tab--icon'>
              <CustomSVGs svg={item.icon} />
            </div>
          )}
          <div className='normalTabs__tab--text'>{item.text}</div>
          {item.count > 0 && item.text === showCountInTab && (
            <div className='normalTabs__tab--count'>
              <span>{item.count}</span>
            </div>
          )}
        </button>
      ))}
    </div>
  );
};

export default NormalTabs;
